var ShapeView = require('../shape');


module.exports = ShapeView.extend({

    shapeSubs: _.extend( {}, ShapeView.prototype.shapeSubs, {
        'shape.onAfterBaseScale': 'resetGlow'
    }),

    /* 
    * This is the change of color from the graphic note toolbar color picker.
    * Note: shouldn't need to worry about 'derived' colors here -- picker would be disabled if they are applied.
    * This should happen the other way around (change model attr for 'color', then change the color in the view ) ...
    * maybe put color on the UI model
    * */
    onChangeColor: function( color ) {

        this.shapeModel.setZoneColor( color );
        this.el.setStrokeAndFill(color);

    },

    // Just change the color in the UI
    noteConsultGroupChange: function() {
        this.el.setStrokeAndFill( this.getColorToApply() );
    },

    onChangeStrokeWidth: function(width) {
        this.el.attr({'stroke-width': width});
    },

    makeExpandedVisibleIndicator: ShapeView.prototype._createGlow


});


/*****************
 ** WEBPACK FOOTER
 ** ./assets/js/modules/canvas/views/shape/graphic/graphic.js
 ** module id = 215
 ** module chunks = 0
 **/